import { RowClassParams } from "ag-grid-community";
import {
  agGridFooterColId,
  agGridGrandFooterColId,
} from "@/components/pages/common/ag-grid/utils/constants/agCommon";
import { agGridOverwrittenIcons } from "@/components/pages/common/ag-grid/utils/constants/agGridOverwrittenIcons";
import { ConfigToRememberStateInStorage } from "@/components/pages/common/ag-grid/utils/types/gridProps";

export const dimensionGridDefaultColDef = {
  sortable: true,
  flex: 10,
  minWidth: 150,
  maxWidth: 700,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
};

export const dimensionGridIcons = {
  groupExpanded: `
            <div style="display: flex; align-items: center; justify-content: center; height: 24px; width: 24px; flex-shrink: 0; flex-grow: 0">
              ${agGridOverwrittenIcons.groupExpanded}
              <svg class="my-custom-expand-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8353 15.0142L10.0047 18.8439L6.17497 15.0142L10.0047 11.1836L13.8353 15.0142ZM8.53174 15.0142L10.0047 16.4871L11.4777 15.0142L10.0047 13.5404L8.53174 15.0142Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.82633 10.0052L4.99577 13.8358L1.16602 10.0052L4.99577 6.17464L8.82633 10.0052ZM3.52279 10.0052L4.99577 11.4782L6.46956 10.0052L4.99577 8.53223L3.52279 10.0052Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8434 10.0052L15.0137 13.8358L11.1831 10.0052L15.0137 6.17464L18.8434 10.0052ZM13.5399 10.0052L15.0137 11.4782L16.4867 10.0052L15.0137 8.53223L13.5399 10.0052Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8353 4.99626L10.0047 8.82682L6.17497 4.99626L10.0047 1.1665L13.8353 4.99626ZM8.53174 4.99626L10.0047 6.47005L11.4777 4.99626L10.0047 3.52327L8.53174 4.99626Z" fill="#3F51B5"/>
              </svg>
            </div>
          `,
  groupContracted: `
            <div style="display: flex; align-items: center; justify-content: center; height: 24px; width: 24px; flex-shrink: 0; flex-grow: 0">
              ${agGridOverwrittenIcons.groupContracted}
              <svg class="my-custom-expand-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8353 15.0142L10.0047 18.8439L6.17497 15.0142L10.0047 11.1836L13.8353 15.0142ZM8.53174 15.0142L10.0047 16.4871L11.4777 15.0142L10.0047 13.5404L8.53174 15.0142Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.82633 10.0052L4.99577 13.8358L1.16602 10.0052L4.99577 6.17464L8.82633 10.0052ZM3.52279 10.0052L4.99577 11.4782L6.46956 10.0052L4.99577 8.53223L3.52279 10.0052Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8434 10.0052L15.0137 13.8358L11.1831 10.0052L15.0137 6.17464L18.8434 10.0052ZM13.5399 10.0052L15.0137 11.4782L16.4867 10.0052L15.0137 8.53223L13.5399 10.0052Z" fill="#3F51B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8353 4.99626L10.0047 8.82682L6.17497 4.99626L10.0047 1.1665L13.8353 4.99626ZM8.53174 4.99626L10.0047 6.47005L11.4777 4.99626L10.0047 3.52327L8.53174 4.99626Z" fill="#3F51B5"/>
              </svg>
            </div>
          `,
};

export const dimensionGridWrapperStyles = {
  " .my-default-expand-icon": { display: "none" },
  " .ag-row-hover .my-default-expand-icon": { display: "block" },
  " .ag-row-hover .my-custom-expand-icon": { display: "none" },
  " .ag-group-expanded,.ag-group-contracted ": {
    mr: 1,
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 1.25,
  },
  " .ag-row-group-leaf-indent": {
    pl: 1,
  },
  " .ag-header-cell-label": {
    color: "grey.700",
  },
  [` [row-id*="${agGridFooterColId}"]`]: {
    "& :hover": {
      bgcolor: "white",
    },
  },
  [` [row-id*="${agGridGrandFooterColId}"]`]: {
    border: 0,
  },
  [` [row-id*="${agGridFooterColId}"] .ag-cell`]: {
    bgcolor: "white",
  },
  ' .ag-row.last-row [col-id="actions"]': {
    border: "none !important",
  },
};

export const getDimensionsRowClass = (params: RowClassParams) => {
  const isLastRow =
    params.node.rowIndex === params.api.getDisplayedRowCount() - 1;
  return isLastRow ? "last-row" : "";
};

export const dimensionsConfigToRememberStateInStorage: ConfigToRememberStateInStorage =
  {
    uniqueNameAsKey: "c8r-DimensionsDataGrid",
  };
